import React from "react";
import { Link, useLocation, Redirect } from "react-router-dom";
import { Box } from "grid-styled";
import { Helmet } from "react-helmet";
import { PageContainer } from "../Grid";
import { H1 } from "../TextStyles";
import { LargeButton } from "../Button";

import FoundationImg from "./bft-foundation-group-shot@2x.png";
import MVMTImg from "./bft-mvmt-group-shot@2x.png";
import { WizardCard, WizardCardContainer } from "../WizardCard";

const styles = [
  {
    code: "MVMT",
    image: MVMTImg,
    title: "MVMT",
    description:
      "MVMT Ergonomic Seating represents a revolutionary advancement for today’s clean room, static control, healthcare, laboratory, industrial, and standing-desk applications.",
    linkPath: "/series",
  },
  {
    code: "foundation",
    image: FoundationImg,
    title: "Foundation",
    description:
      "Our Foundation line consists of reliable ergonomic chairs and stools for all the markets we serve, with models ranging from task chairs to specialized seating for critical performance applications.",
    linkPath: "/upholstery",
  },
];

const Style = () => {
  const location = useLocation();
  const { market } = location.state || {};
  if (!market) {
    return <Redirect to="/market" />;
  }
  return (
    <PageContainer>
      <Helmet>
        <title>Choose Your Style</title>
      </Helmet>
      <H1>Choose Your Style</H1>
      <Box width={1} my="2rem">
        If you’re not sure just where to begin, choose MVMT or Foundation, then answer a few simple
        questions below and we’ll suggest an ideal configuration. Your perfect custom chair is just
        a few clicks away!
      </Box>

      <WizardCardContainer>
        {styles.map((style) => {
          const button = (
            <Link
              to={{
                pathname: style.linkPath,
                state: { ...location.state, style: style.code },
              }}
            >
              <LargeButton secondary>Select {style.title}</LargeButton>
            </Link>
          );

          return (
            <WizardCard
              key={style.code}
              image={style.image}
              title={style.title}
              description={style.description}
              button={button}
            />
          );
        })}
      </WizardCardContainer>
    </PageContainer>
  );
};

export default Style;
